import React from 'react';

const BgVideo = props => {
    return (
        <video autoPlay="autoPlay" loop="loop" muted className="m-0 p-0" style={{
            position: "absolute",
            left:"0",
            width:window.innerWidth
        }}>
            <source src="assets/videos/bg-lic.mp4"/>
            {props.children}
        </video>
    );
};

export default BgVideo;